module.exports = __webpack_public_path__ + "0c9979147e73d5de3bb7b791c90434bc.svg";